import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ClipLoader } from "react-spinners";
import {
  fixtureOpen,
  updateMyRound,
  updatePickRemains,
  updateRedeemPopup,
} from "../Pages/RoundToJoin/roundToJoin.slice";
import { utcToLocalDate, utcToLocalTime } from "../../utils/convertTime";
import teamSelectedIcon from "../../assets/images/team-selected-icon.svg";
import axios from "axios";
import { updateMypot } from "../Pages/Dashboard/dashboard.slice";
import ConfirmPopup from "./PickConfrimPopup";
import { updateConfirmPopup } from "./choosePick.slice";
import useDeviceType from "../Utiles/FindDevice";
import { refreshTokenV2 } from "../services/api";
import { baseURL } from "../services/axiosConfig";
import { createTokenModalOpen } from "../Pages/RoundToJoin/tocken.slice";
import toast, { Toaster } from "react-hot-toast";
import useToastMessage from "../Utiles/Toaster";

const TEAM_BLOCK_WIDTH = 120;

const TeamBlock = ({
  teamType,
  short,
  logo,
  teamId,
  currentFixtureId,
  selectedPickTeam,
  onClick,
  componentType,
}) => {
  const devicetype = useDeviceType();
  const teamInfo = short?.find((ele) => ele.team_type === teamType);
  const code = teamInfo?.code?.slice(0, 3)?.toUpperCase() ?? "";
  const notAvailable = teamInfo?.not_available;

  const isSelected =
    selectedPickTeam?.teamId === currentFixtureId &&
    selectedPickTeam?.teamType === teamType;

  const isClickable = componentType === "choose pick" && !notAvailable;

  const isHome = teamType === "home";

  const logoSizeDesktop = 32; // px
  const codeWidthDesktop = 36; // px
  const dotWidth = 18; // px

  const fixedTextClass = "w-[36px] text-center whitespace-nowrap";

  if (devicetype === "mobile") {
    return (
      <div
        className={`
          flex items-center justify-center gap-1 px-2 py-1 rounded-md min-w-[80px] min-h-[38px]
          ${isClickable ? "cursor-pointer" : ""}
          ${isSelected ? "bg-[#E9F4FF]" : ""} transition
          ${notAvailable ? "opacity-50 pointer-events-none" : ""}
          relative
        `}
        onClick={() => {
          if (isClickable) onClick(currentFixtureId, teamType);
        }}
        style={{
          border: isSelected ? "2px solid #0081FB" : "2px solid transparent",
        }}
      >
        {/* {isSelected && (
          <img
            src={teamSelectedIcon}
            alt="Selected"
            className="absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full shadow-md"
          />
        )} */}
        {isHome ? (
          <>
            {/* Dot */}
            <span
              style={{
                width: dotWidth,
                display: "flex",
                justifyContent: "center",
              }}
            >
              {isSelected && (
                <img
                  src={teamSelectedIcon}
                  alt="Selected"
                  className="w-[14px] h-[14px]"
                />
              )}
            </span>
            {/* Fixed-width code text */}
            <span
              className={`font-inter text-base text-sm ${isSelected ? "text-[#000]" : "text-[#00000080]"
                } ${fixedTextClass}`}
            >
              {code}
            </span>
            {/* Fixed-size logo */}
            <img
              src={logo}
              alt={`${teamType}-logo`}
              className={`object-contain ml-2`}
              style={{ width: logoSizeDesktop, height: logoSizeDesktop }}
            />
          </>
        ) : (
          <>
            <img
              src={logo}
              alt={`${teamType}-logo`}
              className="object-contain mr-2"
              style={{ width: logoSizeDesktop, height: logoSizeDesktop }}
            />
            <span
              className={`font-inter text-base text-sm ${isSelected ? "text-[#000]" : "text-[#00000080]"
                } ${fixedTextClass}`}
            >
              {code}
            </span>
            {/* Dot */}
            <span
              style={{
                width: dotWidth,
                display: "flex",
                justifyContent: "center",
              }}
            >
              {isSelected && (
                <img
                  src={teamSelectedIcon}
                  alt="Selected"
                  className="w-[14px] h-[14px]"
                />
              )}
            </span>
          </>
        )}
      </div>
    );
  }

  return (
    <div
      className={`flex items-center gap-2 transition-all duration-150
        ${isClickable
          ? "cursor-pointer hover:border-blue-500 hover:bg-[#0000001A]"
          : ""
        }
        ${isSelected ? "border-blue-500 bg-[#0000001A]" : "border-transparent"}
        ${notAvailable ? "opacity-50 pointer-events-none" : ""}
        rounded-[5px] border p-1 min-w-0`}
      onClick={() => {
        if (isClickable) onClick(currentFixtureId, teamType);
      }}
      style={{
        width: TEAM_BLOCK_WIDTH,
        minWidth: TEAM_BLOCK_WIDTH,
        maxWidth: TEAM_BLOCK_WIDTH,
        justifyContent: isHome ? "flex-start" : "flex-end",
      }}
    >
      {isHome ? (
        <>
          <span
            style={{ width: 18, display: "flex", justifyContent: "center" }}
          >
            {isSelected && (
              <img
                src={teamSelectedIcon}
                alt="Selected"
                className="w-[14px] h-[14px]"
                style={{ display: "block" }}
              />
            )}
          </span>
          <span
            className={`w-[2.5ch] font-inter text-base ${isSelected ? "text-[#000]" : "text-[#00000080]"
              } whitespace-nowrap text-center`}
          >
            {code}
          </span>
          <img
            src={logo}
            alt={`${teamType}-logo`}
            className="h-8 w-8 object-contain ml-2"
          />
        </>
      ) : (
        <>
          <img
            src={logo}
            alt={`${teamType}-logo`}
            className="h-8 w-8 object-contain mr-2"
          />
          <span
            className={`w-[2.5ch] font-inter text-base ${isSelected ? "text-[#000]" : "text-[#00000080]"
              } whitespace-nowrap text-center`}
          >
            {code}
          </span>
          <span
            style={{ width: 18, display: "flex", justifyContent: "center" }}
          >
            {isSelected && (
              <img
                src={teamSelectedIcon}
                alt="Selected"
                className="w-[14px] h-[14px]"
                style={{ display: "block" }}
              />
            )}
          </span>
        </>
      )}
    </div>
  );
};

const TeamSection = ({
  short,
  start,
  hometeam_logo,
  awayteam_logo,
  index,
  fixtureLeangth,
  id,
  selectedPickTeam,
  handleClickTeamSide,
  componentType,
}) => {
  const devicetype = useDeviceType();
  if (devicetype === "mobile") {
    return (
      <div
        className={`flex items-center justify-between px-2 py-2 bg-white
      ${index !== fixtureLeangth - 1 ? "border-b border-[#eee]" : ""}`}
      >
        {/* Home Team */}
        <div className="flex-shrink-0 flex-grow-0" style={{ width: 80 }}>
          <TeamBlock
            teamType="home"
            short={short}
            logo={hometeam_logo}
            teamId={id}
            currentFixtureId={id}
            selectedPickTeam={selectedPickTeam}
            onClick={handleClickTeamSide}
            componentType={componentType}
          />
        </div>
        {/* Time */}
        <div
          className="flex-shrink-0 flex-grow-0 flex items-center justify-center  text-center bg-[#F6F6FA] rounded-lg text-[#37003C99] font-normal text-[12px] mx-2"
          style={{ width: 120, height: 30 }}
        >
          {/* <div className="flex items-center justify-center min-w-[170px] h-8 bg-[#F6F6FA] rounded-lg text-black text-[#37003C99] font-archivo text-base px-5"> */}
          {utcToLocalDate(start)} | {utcToLocalTime(start)}
          {/* </div> */}
        </div>
        {/* Away Team */}
        <div className="flex-shrink-0 flex-grow-0" style={{ width: 80 }}>
          <TeamBlock
            teamType="away"
            short={short}
            logo={awayteam_logo}
            teamId={id}
            currentFixtureId={id}
            selectedPickTeam={selectedPickTeam}
            onClick={handleClickTeamSide}
            componentType={componentType}
          />
        </div>
      </div>
    );
  }

  // Desktop/tablet renders full date and time in center
  return (
    <div
      className={`flex items-center justify-between px-6 py-2 ${index !== fixtureLeangth - 1 ? "border-b border-[#eee]" : ""
        }`}
    >
      <TeamBlock
        teamType="home"
        short={short}
        logo={hometeam_logo}
        teamId={id}
        currentFixtureId={id}
        selectedPickTeam={selectedPickTeam}
        onClick={handleClickTeamSide}
        componentType={componentType}
      />
      <div
        className="flex items-center justify-center min-w-[170px] h-8
       rounded-lg border-[1px] p-4 border-gray-500 bg-[#F5F2F580] text-[#37003C99] font-archivo text-base px-5"
      >
        {/* <div className="flex items-center justify-center min-w-[170px] h-8 bg-[#F6F6FA] rounded-lg text-black text-[#37003C99] font-archivo text-base px-5"> */}
        {utcToLocalDate(start)} | {utcToLocalTime(start)}
        {/* </div> */}
      </div>
      <TeamBlock
        teamType="away"
        short={short}
        logo={awayteam_logo}
        teamId={id}
        currentFixtureId={id}
        selectedPickTeam={selectedPickTeam}
        onClick={handleClickTeamSide}
        componentType={componentType}
      />
    </div>
  );
};

function FixturePopup({ myPickHandler, fixturesData }) {
  const dispatch = useDispatch();

  const {
    loading,
    v2Fixtures,
    matchWeeks,
    type,
    fixturePopupOpen,
    choosePickDetail,
    selectectTimeType,
  } = useSelector((state) => state.roundToJoin);

  const { showToast, showErrorToast } = useToastMessage();
  const { confrimPopup } = useSelector((state) => state.choosePick);
  const [isConfirm, setIsConfirm] = useState(false);
  const { myRounds, roundsToJoin } = useSelector((state) => state.dashboard.potInfo);
  const rountMyRound = useSelector((state) => state.roundToJoin.myRound);
  const tokenRemaining = useSelector((state) => state.token.tokenRemaining)
  const roundToJoinPotData = useSelector((state) => state.roundToJoin.roundToJoinPotData);
  const { leagueId, selectedPot } = useSelector((state) => state.roundToJoin);
  const [isEntyClosed, setIsEntryClosed] = useState(false)

  const [selectedPick, setSelectedPick] = useState({});
  const [selectedPickTeam, setSelectedPickTeam] = useState({
    teamType: "",
    teamId: "",
  });

  const devicetype = useDeviceType();
  const componentType = useSelector((state) => state.roundToJoin.componentType);
  const potId = choosePickDetail?.potId;
  useEffect(() => {
    if (confrimPopup.updateFixture) {
      updatePick().finally(() => {
        dispatch(fixtureOpen(false));
        dispatch(
          updateConfirmPopup({ updateFixture: false, openPopup: false })
        );
      });
    }
  }, [confrimPopup]);

  useEffect(() => {
    const path = window.location.pathname;
    let potValue = 0
    let currentPotValue = 0
    if (path === "/dashboard") {
      const pot = roundsToJoin[0]?.pots.find((ele) => ele.id === selectedPot);

      potValue = pot?.pot_value
      currentPotValue = pot?.current_pot_value
    }
    if (path === "/rounds") {
      const selectedLeague = roundToJoinPotData?.find(ele => ele.league_id === Number(leagueId))
      const findSelectedPot = selectedLeague?.pots.find(ele => ele.id === selectedPot);

      potValue = findSelectedPot?.pot_value
      currentPotValue = findSelectedPot?.current_pot_value
    }
    if (potValue > currentPotValue) {
      setIsEntryClosed(false)
    } else {
      setIsEntryClosed(true)
    }
  }, [selectedPot])



  useEffect(() => {
    if (fixturePopupOpen && v2Fixtures?.length) {
      let found = false;
      for (const fixture of v2Fixtures) {
        const homeShort = fixture.short?.find(
          (s) => s.team_type === "home" && s.predicted
        );
        if (homeShort) {
          setSelectedPick({
            selectTeam: fixture.hometeam,
            teamType: "home",
            teamId: fixture.id,
            logo: fixture.hometeam_logo,
            short: homeShort.code,
            pickId: choosePickDetail.pickId,
            matchWeekId: choosePickDetail?.matchWeekId,
          });
          setSelectedPickTeam({ teamType: "home", teamId: fixture.id });
          found = true;
          break;
        }
        const awayShort = fixture.short?.find(
          (s) => s.team_type === "away" && s.predicted
        );
        if (awayShort) {
          setSelectedPick({
            selectTeam: fixture.awayteam,
            teamType: "away",
            teamId: fixture.id,
            logo: fixture.awayteam_logo,
            short: awayShort.code,
            pickId: choosePickDetail.pickId,
            matchWeekId: choosePickDetail?.matchWeekId,
          });
          setSelectedPickTeam({ teamType: "away", teamId: fixture.id });
          found = true;
          break;
        }
      }
      if (!found) {
        setSelectedPick({});
        setSelectedPickTeam({ teamType: "", teamId: "" });
      }
    }
  }, [fixturePopupOpen, v2Fixtures, potId, choosePickDetail?.matchWeekId]);

  useEffect(() => {
    if (!fixturePopupOpen) {
      setSelectedPick({});
      setSelectedPickTeam({ teamType: "", teamId: "" });
    }
  }, [fixturePopupOpen]);

  const handleClickTeamSide = (fixtureId, teamType) => {
    const selectedFixture = v2Fixtures.find((ele) => ele.id === fixtureId);
    if (!selectedFixture) return;
    const selectTeam = selectedFixture[`${teamType}team`];
    const logo = selectedFixture[`${teamType}team_logo`];
    const shortCode = selectedFixture?.short?.find(
      (s) => s.team_type === teamType
    )?.code;
    setSelectedPick({
      selectTeam,
      teamType,
      teamId: fixtureId,
      logo,
      short: shortCode,
      pickId: choosePickDetail.pickId,
      matchWeekId: choosePickDetail?.matchWeekId,
    });
    setSelectedPickTeam({ teamType, teamId: fixtureId });
  };

  if (!fixturePopupOpen) return null;

  async function updatePick() {
    try {
      const rawToken = localStorage.getItem("access_token");
      const token = rawToken ? JSON.parse(rawToken) : null;
      if (!token) {
        console.warn("Access token is missing");
        return;
      }
      if (!selectedPick || !selectedPick.pickId || !selectedPick.selectTeam) {
        console.warn("Invalid pick data");
        return;
      }
      const path = window.location.pathname;
      const updatePrediction = (rounds, pickId, updatedPrediction) => {
        return rounds.map((round) => ({
          ...round,
          pick_id: round.pick_id.map((pick) => {
            if (pick.pick_id === pickId) {
              return {
                ...pick,
                prediction: {
                  ...pick.prediction,
                  ...updatedPrediction,
                  system: pick.prediction.system,
                },
              };
            }
            return pick;
          }),
        }));
      };

      if (path === "/dashboard") {
        const selectedPot = myRounds[0].pots.find((ele) => ele.id === potId);
        if (
          Array.isArray(selectedPot?.pick_id) &&
          selectedPot.pick_id.length > 0
        ) {
          const existingPrediction = selectedPot.pick_id.find(
            (item) => item.pick_id === selectedPick.pickId
          )?.prediction?.team;

          const apiUrl =
            existingPrediction && existingPrediction !== "NPY"
              ? `${baseURL}/pot/selectpicks/${selectedPick.pickId}`
              : `${baseURL}/pot/selectpicks`;

          const axiosMethod =
            existingPrediction && existingPrediction !== "NPY"
              ? axios.put
              : axios.post;

          const res = await axiosMethod(
            apiUrl,
            {
              pick: selectedPick.pickId,
              prediction: selectedPick.selectTeam,
              team: selectedPick.teamType,
              pot: potId,
              fixture: selectedPick.teamId,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res.data?.data?.code === 200) {
            const userInfo = localStorage.getItem("userInfo");
            const userId = userInfo ? JSON.parse(userInfo).userId : null;
            window.dataLayer.push({
              'userId': userId,
              'event': 'click',
              'clickText': `Confirm Pick ${choosePickDetail.label.split(" ")[1]}`,
              'clickID': 'btn-pick-team',
              'roundID': potId,
              'leagueID': selectedPot?.season_name,
              'matchWeek': `${v2Fixtures?.[0]?.match_week?.split("-")[1] || 1}`,
              'teamID': res.data?.data?.short_name
            });

            // Enter round event

            // window.dataLayer.push({
            //   'userId': userId,
            //   'event': 'enter_round',
            //   'roundId': potId,
            //   'fixtureId': res.data?.data?.short_name,
            //   'entryType': 'tokens',
            //   'tokenCost': 5
            // });

            const updatedRounds = myRounds.map((round) => ({
              ...round,
              pots: round.pots.map((pot) => {
                if (pot.id === potId) {
                  return {
                    ...pot,
                    pick_id:
                      pot.pick_id?.map((item) => {
                        if (item.pick_id === selectedPick.pickId) {
                          return {
                            ...item,
                            prediction: {
                              ...item.prediction,
                              logo: selectedPick.logo,
                              short_name: selectedPick.short,
                              team: selectedPick.selectTeam,
                              team_type: selectedPick.teamType,
                              system: item.prediction.system,
                            },
                          };
                        }
                        return item;
                      }) || [],
                  };
                }
                return pot;
              }),
            }));
            dispatch(updateMypot(updatedRounds));
            if (existingPrediction === "NPY") {
              showToast("Team selected successfully.");
            } else {
              showToast("Team updated successfully.");
            }
          }
        }
      }
      if (path === "/rounds") {
        const selectedPot = rountMyRound.find((ele) => ele.id === potId);
        if (
          Array.isArray(selectedPot?.pick_id) &&
          selectedPot.pick_id.length > 0
        ) {
          const existingPrediction = selectedPot.pick_id.find(
            (item) => item.pick_id === selectedPick.pickId
          )?.prediction?.team;

          const apiUrl =
            existingPrediction && existingPrediction !== "NPY"
              ? `${baseURL}/pot/selectpicks/${selectedPick.pickId}`
              : `${baseURL}/pot/selectpicks`;

          const axiosMethod =
            existingPrediction && existingPrediction !== "NPY"
              ? axios.put
              : axios.post;

          const res = await axiosMethod(
            apiUrl,
            {
              pick: selectedPick.pickId,
              prediction: selectedPick.selectTeam,
              team: selectedPick.teamType,
              pot: potId,
              fixture: selectedPick.teamId,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res.data?.data?.code === 200) {
            const userInfo = localStorage.getItem("userInfo");
            const userId = userInfo ? JSON.parse(userInfo).userId : null;
            window.dataLayer.push({
              'userId': userId,
              'event': 'click',
              'clickText': `Confirm Pick ${choosePickDetail?.label.split(" ")[1]}`,
              'clickID': 'btn-pick-team',
              'roundID': potId,
              'leagueID': selectedPot?.season_name,
              'matchWeek': `${v2Fixtures?.[0]?.match_week?.split("-")[1] || 1}`,
              'teamID': res.data?.data?.short_name
            });
            const updatedRounds = updatePrediction(
              rountMyRound,
              selectedPick.pickId,
              {
                logo: selectedPick.logo,
                short_name: selectedPick.short,
                team: selectedPick.selectTeam,
                team_type: selectedPick.teamType,
              }
            );
            if (existingPrediction === "NPY") {
              showToast("Team selected successfully.");
            } else {
              showToast("Team updated successfully.");
            }
            dispatch(updateMyRound(updatedRounds));
          }
        }
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      console.error("Update Pick Error:", error);
    }
  }

  const handleConfirm = () => {
    dispatch(updateConfirmPopup({ openPopup: false, updateFixture: true }));
  };

  const handleCancel = () => {
    dispatch(updateConfirmPopup({ openPopup: false, updateFixture: false }));
  };

  return (
    <div
      className={
        "fixed inset-0 z-50 bg-black/90 flex justify-center items-center p-4"
      }
      onClick={() => {
        dispatch(fixtureOpen(false));
        dispatch(
          updateConfirmPopup({ openPopup: false, updateFixture: false })
        );
      }}
    >
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      {confrimPopup.openPopup && (
        <ConfirmPopup
          message={
            selectectTimeType === "choose"
              ? "Confirm your team selection"
              : "Do you want to update the team?"
          }
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      <div
        className={
          devicetype === "mobile"
            ? "bg-white w-full max-h-[90vh] flex flex-col overflow-hidden"
            : "bg-white rounded-lg shadow-lg max-w-md w-full max-h-[90vh] flex flex-col overflow-hidden sm:max-w-lg md:max-w-xl lg:max-w-[45%]"
        }
        onClick={(e) => e.stopPropagation()}
      >
        {/* Mobile header */}
        <div
          className={
            devicetype === "mobile"
              ? "bg-[#0081FB] py-3"
              : "bg-[#0081FB] p-4 rounded-t-lg"
          }
        >
          <h4 className="text-center text-white text-lg font-archivo font-semibold m-0">
            Fixtures - Match Week {v2Fixtures[0]?.match_week?.split("-")[1] || 1}
          </h4>
        </div>
        {/* Fixture list */}
        <div
          className={
            devicetype === "mobile"
              ? "overflow-y-auto flex-1 bg-white"
              : "overflow-y-auto px-4 py-1 flex-1"
          }
        >
          {loading ? (
            <div className="flex items-center justify-center h-40">
              <ClipLoader color="#36d7b7" />
            </div>
          ) : v2Fixtures?.length === 0 ? (
            <div className="text-center text-gray-500 py-8">No data found</div>
          ) : (
            <>
              {v2Fixtures?.map((team, index) => (
                <TeamSection
                  key={team.id || index}
                  {...team}
                  index={index}
                  fixtureLeangth={v2Fixtures.length}
                  selectedPickTeam={selectedPickTeam}
                  handleClickTeamSide={handleClickTeamSide}
                  componentType={componentType}
                />
              ))}

              {componentType !== "choose pick" ? (
                <div className="p-2 sticky bottom-0 z-10 bg-white">
                  <button
                    className={`w-full mt-1 ${isEntyClosed ? 'bg-gray-500' : "bg-[#00C05B]"}  text-white font-bold text-base sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition`}
                    onClick={() => {
                      const path = window.location.pathname;
                      const userInfo = JSON.parse(localStorage?.getItem("userInfo"));
                      const userId = userInfo ? userInfo.userId : null;

                      let potToken = 0
                      let potValue = 0
                      let currentPotValue = 0
                      let maxPotValue = 0

                      if (path === "/dashboard") {
                        const pot = roundsToJoin[0].pots.find((ele) => ele.id === selectedPot);
                        potToken = pot.pot_token
                        potValue = pot.pot_value
                        currentPotValue = pot.current_pot_value
                        maxPotValue = pot.max_pot_value
                        window.dataLayer.push({
                          'userId': userId,
                          'event': 'click',
                          'clickText': 'Play Now',
                          'clickID': 'btn-play-now',
                          'clickURL': '',
                          'roundId': pot.id,
                          'leagueId': pot.season_name,
                          'sportId': pot.game_name
                        });
                      }
                      if (path === "/rounds") {
                        const selectedLeague = roundToJoinPotData.find(ele => ele.league_id === Number(leagueId))
                        const findSelectedPot = selectedLeague.pots.find(ele => ele.id === selectedPot);
                        potToken = findSelectedPot.pot_token
                        potValue = findSelectedPot.pot_value
                        currentPotValue = findSelectedPot.current_pot_value
                        maxPotValue = findSelectedPot.max_pot_value
                        window.dataLayer.push({
                          'userId': userId,
                          'event': 'click',
                          'clickText': 'Play Now',
                          'clickID': 'btn-play-now',
                          'clickURL': '',
                          'roundId': findSelectedPot.id,
                          'leagueId': findSelectedPot.season_name,
                          'sportId': findSelectedPot.game_name
                        });
                      }

                      if (maxPotValue > currentPotValue) {
                        myPickHandler?.(selectedPickTeam);
                        dispatch(updatePickRemains(2));
                        dispatch(fixtureOpen(false));
                        dispatch(updateRedeemPopup(true));
                      } else {
                        showErrorToast('Entry closed for this round, please join other rounds.')
                      }

                    }}
                  >
                    Play Now
                  </button>
                </div>
              ) : (
                <div className="p-2 sticky flex gap-2 bottom-0 z-10 bg-white">
                  <button
                    className="w-full mt-1 text-black border font-bold text-base sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition"
                    onClick={() => {
                      dispatch(fixtureOpen(false));
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={!selectedPickTeam.teamId}
                    className={`w-full ${!selectedPickTeam.teamId
                      ? "bg-gray-500 opacity-50"
                      : "bg-[#00C05B]"
                      } mt-1 text-white font-bold
                     text-base sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition`}
                    onClick={() => {
                      dispatch(updateConfirmPopup({ openPopup: true }));
                      // dispatch(fixtureOpen(false));
                      // updatePick();
                    }}
                  >
                    Confirm
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default FixturePopup;
